export function delayUntilIdle(callback) {
  // Missing safari support: https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
  if (window.requestIdleCallback) {
    const id = window.requestIdleCallback(callback, {
      timeout: 5000
    });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(callback, 1000);
  return () => window.clearTimeout(id);
}